import dayjs from "dayjs";
import HttpClient from "../../utils/http";
import {
  getNeedLabels,
  getSuggestedLabel,
  needDetails,
  needStatus,
  needsArea,
  needsBrand,
  needsDownload,
  needsFilters,
  needsList,
  updateNeeds,
} from "../constants/api_endpoints";

export function getNeeds({
  paginationModel,
  concerningToId,
  subcategoryId,
  areasId,
  status,
  cityId,
  startDate,
  endDate,
  sortBy,
  sortOrder,
  state,
  keyword,
  district,
  label,
  orgId
}: {
  paginationModel: { pageSize: number; page: number };
  concerningToId: number | null;
  subcategoryId: number | null;
  areasId: number | null;
  status: number | null;
  cityId: number | null;
  startDate: string | null;
  endDate: string | null;
  sortBy?: string | null;
  sortOrder: string | null;
  state: number | null;
  keyword:string;
  district: number | null;
  label:string;
  orgId?: number | null;
}) {
  console.log("concerningToId", concerningToId);
  let url =
    needsList +
    `?size=${paginationModel.pageSize}&page=${paginationModel.page}`;

  if (concerningToId) {
    url += `&categoryId=${concerningToId}`;
  }
  if (subcategoryId) {
    url += `&subCategoryId=${subcategoryId}`;
  }
  if (areasId) {
    url += `&areaId=${areasId}`;
  }
  if (status) {
    url += `&statusId=${status}`;
  }
  if (sortBy) {
    url += `&sortBy=${sortBy}`;
  }
  if (sortOrder) {
    url += `&sortOrder=${sortOrder}`;
  }
  if (state) url += `&stateId=${state}`;

  if (label) url += `&label=${label}`;

  if (startDate && endDate) {
    let formattedStartDate = dayjs(startDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedEndDate = dayjs(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    url += `&dateFrom=${formattedStartDate}`;
    url += `&dateTo=${formattedEndDate}`;
  }

  // if(status){
  //   url+=`&areaId=${status}`;
  // }
  if (cityId) {
    url += `&cityId=${cityId}`;
  }
  if (district) {
    url += `&districtId=${district}`;
  }
  if(keyword!==""){
    url += `&keyword=${keyword}`
  }
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}

export function downloadNeeds({
  page,
  size,
  concerningToId,
  subcategoryId,
  areasId,
  status,
  cityId,
  startDate,
  endDate,
  format,
  sortBy,
  sortOrder,
  state,
  label,
  orgId
}: {
  page: number | null;
  size: number | null;
  concerningToId: number | null;
  subcategoryId: number | null;
  areasId: number | null;
  status: number | null;
  cityId: number | null;
  startDate: string | null;
  endDate: string | null;
  format: string;
  sortBy?: string | null;
  sortOrder: string | null;
  state: number | null;
  label:string | null;
  orgId?: number | null;
}) {
  let url = needsDownload + `?page=${page}&size=${size}&download=true&format=${format}`;
  if (concerningToId) {
    url += `&categoryId=${concerningToId}`;
  }
  if (subcategoryId) {
    url += `&subCategoryId=${subcategoryId}`;
  }
  if (areasId) {
    url += `&areaId=${areasId}`;
  }
  if (status) {
    url += `&statusId=${status}`;
  }

  if (startDate && endDate) {
    let formattedStartDate = dayjs(startDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    let formattedEndDate = dayjs(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    url += `&dateFrom=${formattedStartDate}`;
    url += `&dateTo=${formattedEndDate}`;
  }

  if(label){
    url+=`&label=${label}`;
  }
  if (cityId) {
    url += `&cityId=${cityId}`;
  }
  if (sortBy) {
    url += `&sortBy=${sortBy}`;
  }
  if (sortOrder) {
    url += `&sortOrder=${sortOrder}`;
  }
  if (state) url += `&state=${state}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url, { responseType: "blob" });
}

export function getNeed(id: string) {
  return HttpClient.get(`${needDetails}?needId=${id}`);
}

export function downloadNeed(id: string, format: string) {
  return HttpClient.get(
    `${needDetails}?needId=${id}&download=true&format=${format}`,
    { responseType: "blob" }
  );
}

// Statuses an admin may set on a need (In Progress, Resolved, Closed) -
// backend-filtered, so this always reflects what's actually assignable
// rather than a hardcoded guess at status ids.
export function getNeedsStatus() {
  return HttpClient.get(needStatus);
}

export function patchNeedStatus(
  id: string,
  formData:FormData
  // status: number | null,
  // comment: string | null,
  // notes: string | null,
  // sysgenCategory?: number | null,
  // sysgenSubCategory?: number | null | string,
  // sysgenArea?: number | null | string,
  // sysgenBrand?: number | null | string
) {
  return HttpClient.patch(`${needStatus}${id}`,formData, {
    headers: {
        "Content-Type": "multipart/form-data",
    },
});
}

export function getNeedsFilters() {
  return HttpClient.get(needsFilters);
}

export function getArea({
  categoryId,
  subcategoryId,
}: {
  categoryId: number | null;
  subcategoryId: number | null;
}) {
  let url = `${needsArea}?categoryId=${categoryId}&subcategoryId=${subcategoryId}`;

  return HttpClient.get(url, { headers: { locale: "en" } });
}

export function getBrand({
  categoryId,
  subcategoryId,
}: {
  categoryId: number | null;
  subcategoryId: number | null;
}) {
  let url = `${needsBrand}?categoryId=${categoryId}&subcategoryId=${subcategoryId}`;

  return HttpClient.get(url, { headers: { locale: "en" } });
}


export function getNeedlabelsApi({
  page,
  size,
  days,
  orgId
}: {
  page: number | null;
  size: number | null;
  days:number | null;
  orgId?: number | null;
}) {
  let url = `${getNeedLabels}?page=${page}&size=${size}&days=${days}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}

export function getNeedSuggestedlabelsApi({
  fromDate,
  toDate,
  orgId,
}: {
  fromDate: string | null;
  toDate: string | null;
  orgId?: number | null;
}) {
  let url = `${getSuggestedLabel}?fromDate=${fromDate}&toDate=${toDate}`;
  if (orgId) url += `&orgId=${orgId}`;
  return HttpClient.get(url);
}

export function postNeedlabels({
  label,
  orgId,
}: {
  label: string;
  orgId?: number | null;
}) {
  let url = `${getNeedLabels}`;
  return HttpClient.post(url,{
    "label": label,
    "orgId": orgId
  });
}

export function patchBulkNeeds({
  needId,
  status,
  comments,
  selectedFile,
  statusName,
}: {
  needId: number[];
  status:number;
  comments:string;
  selectedFile:File |null;
  // Which remarks field the comments go under - the backend now requires
  // resolutionRemarks/closureRemarks specifically for those two statuses,
  // separate from the general-purpose "comments" field.
  statusName?: string;
}) {
  var formData = new FormData();
  formData.append("needId", JSON.stringify(needId));
  formData.append('status', status.toString());
  if(selectedFile)
    formData.append('file',selectedFile)
  if(comments) {
    formData.append('comments', comments);
    if (statusName === "Resolved") formData.append('resolutionRemarks', comments);
    if (statusName === "Closed") formData.append('closureRemarks', comments);
  }
  let url = `${updateNeeds}`;
  return HttpClient.patch(url,formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

